import { ApiKeyDataType } from '../api-key/api-key.model';

export enum FormMode {
  Edit = 'edit',
  Create = 'create',
  View = 'view',
}

export type ApiKeyCreationParams = {
  name: string;
  scope: string;
  expiryDate: string;
  projectId?: number;
  data?: ApiKeyDataType;
};

export type ApiKeyUpdateParams = {
  name: string;
  data?: ApiKeyDataType;
};

export type ApiKeyForm = {
  scope: string;
  expiryDate: string | null;
  name: string;
  projectId: number[];
  web?: {
    developingLocally: boolean;
    source: string[];
    referer: string[];
    resumable: boolean;
  };
  mobile?: {
    applicationId: string[];
  };
};
